import { createSlice } from '@reduxjs/toolkit';

const skillLevelSlice = createSlice({
  name: 'skillLevels',
  initialState: {
    skillLevels: [],
    dataValid: false
  },
  reducers: {
    setSkillLevels(state, action) {
      
      if (!action || !action.payload || !action.payload.skillLevels) {
          state.skillLevels = [];
          state.dataValid = false;
      } else {
        state.skillLevels = action.payload.skillLevels;
        state.dataValid = !!action.payload.dataValid;
      }
    },
    patchSkillLevels(state, action) {
//console.log("----------Skilllevel-slice.patchSkillLevels");

      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.skillLevels) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

        let userLevels = state.skillLevels.find(item => item.userId === updatedUserLevels.userId);

        if (!userLevels) {
          userLevels = {
            userId: updatedUserLevels.userId,
            skillLevels: []
          }

          state.skillLevels.push(userLevels);
        }

        if (!userLevels.skillLevels) {
          userLevels.skillLevels = [];
        }

        if(updatedUserLevels.skillLevels){
          updatedUserLevels.skillLevels.forEach(updatedLevel => {
            let level = userLevels.skillLevels.find(item => item.id === updatedLevel.id);

            if (!level) {
              level = {
                id: updatedLevel.id,
                proficiency: updatedLevel.proficiency,
              }
            } else {
              level.proficiency = updatedLevel.proficiency;
            }

          });
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(userLevels.skills){
              //Remove skill from list
              let index = userLevels.skills.findIndex(item => item.id === removedSkill.id);
              if(index => 0){
                userLevels.skills.splice(index, 1);
              }
            }
          });
        }

      });
    },
    patchLanguageLevels(state, action) {
      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.groupMembers) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

        let userLevels = state.skillLevels.find(item => item.id === updatedUserLevels.userId);

        if(!userLevels) return;

        if(updatedUserLevels.skillLevels){
          if (!userLevels.languages) {
            userLevels.languages = updatedUserLevels.skillLevels;
          } else {
            updatedUserLevels.skillLevels.forEach(updatedLevel => {
              let level = userLevels.languages.find(item => item.id === updatedLevel.id);
              if (!level) {
                level = {
                  id: updatedLevel.id,
                  proficiency: updatedLevel.proficiency,
                }
                userLevels.languages.push(level);
              } else {
                level.proficiency = updatedLevel.proficiency;
              }

            });
          }
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(userLevels.languages){
              //Remove skill from list
              let index = userLevels.languages.findIndex(item => item.id === removedSkill.id);
              if(index => 0){
                userLevels.languages.splice(index, 1);
              }
            }
          });
        }

      });

    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const skillLevelActions = skillLevelSlice.actions;

export default skillLevelSlice;